import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

/**
 * Fixes an Angular Material 19 accessibility violation where mat-stepper renders
 * role="tablist" on its host element while also containing role="tabpanel" descendants.
 * ARIA requires tablist to own only tab elements.
 *
 * Fix: moves role="tablist" to the header container (horizontal steppers only)
 * and sets role="group" on the host.
 */
@Directive({
  selector: 'mat-stepper',
  standalone: false
})
export class StepperAriaFixDirective implements AfterViewInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    const host = this.el.nativeElement as HTMLElement;

    this.renderer.setAttribute(host, 'role', 'group');

    const headerContainer = host.querySelector('.mat-horizontal-stepper-header-container');
    if (headerContainer) {
      this.renderer.setAttribute(headerContainer, 'role', 'tablist');
      const orientation = host.getAttribute('aria-orientation');
      if (orientation) {
        this.renderer.setAttribute(headerContainer, 'aria-orientation', orientation);
        this.renderer.removeAttribute(host, 'aria-orientation');
      }
    }
  }
}
